import styled from 'styled-components';
import CEOMessageBG from '../../../assets/images/CEOMessageBG.webp';

export const Container = styled.div`
  background-image: url(${CEOMessageBG});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 104px 28px;
  margin-top: 56px;
`;

export const MessageText = styled.div`
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  color: white;
  margin-top: 33px;
  text-align: center;
  max-width: 828px;
  @media (max-width: 600px) {
    font-size: 22px;
  }
`;

export const DescriptionText = styled.div`
  margin-top: 40px;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: white;
  font-weight: normal;
  & span {
    font-weight: bold;
  }
  @media (max-width: 600px) {
    font-size: 16px;
  }
`;
